// extracted by mini-css-extract-plugin
export default {"Virtual":"Virtual_Virtual__ckiQm","left":"Virtual_left__+5j2W","wrapper":"Virtual_wrapper__R8cgq"};